import { cn } from "@/lib/utils";

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn("rounded-xl border bg-[var(--card2)] border-[var(--border2)]", className)}
      style={{ borderColor: "var(--border2)" }}
      {...props}
    >
      {children}
    </div>
  );
}

export function SectionLabel({ children, className }) {
  return (
    <span className={cn("text-xs font-medium tracking-wider uppercase text-[var(--text-muted)]", className)}>
      {children}
    </span>
  );
}

// Status color mapping for the whole engine status vocabulary
const STATUS_COLORS = {
  "ENTRY CONDITIONS SATISFIED": { c: "#21C58E", bg: "rgba(33,197,142,0.12)" },
  "HIGH-QUALITY SETUP": { c: "#21C58E", bg: "rgba(33,197,142,0.12)" },
  WATCH: { c: "#60A5FA", bg: "rgba(96,165,250,0.12)" },
  "SETUP FORMING": { c: "#F5B942", bg: "rgba(245,185,66,0.12)" },
  "WAITING FOR CONFIRMATION": { c: "#F5B942", bg: "rgba(245,185,66,0.12)" },
  "NEWS PROTECTION ACTIVE": { c: "#F5B942", bg: "rgba(245,185,66,0.12)" },
  "ELEVATED-RISK ENVIRONMENT": { c: "#F5B942", bg: "rgba(245,185,66,0.12)" },
  "NO TRADE": { c: "#98A2B3", bg: "rgba(152,162,179,0.10)" },
  "MARKET UNCLEAR": { c: "#98A2B3", bg: "rgba(152,162,179,0.10)" },
  "ENTRY MISSED — DO NOT CHASE": { c: "#EF6262", bg: "rgba(239,98,98,0.12)" },
  "SETUP INVALIDATED": { c: "#EF6262", bg: "rgba(239,98,98,0.12)" },
  "TRADING LOCKED BY YOUR RISK PLAN": { c: "#FF4D67", bg: "rgba(255,77,103,0.14)" },
  "MARKET DATA STALE": { c: "#FF4D67", bg: "rgba(255,77,103,0.14)" },
  "MARKET DATA UNAVAILABLE": { c: "#FF4D67", bg: "rgba(255,77,103,0.14)" },
};

export function StatusBadge({ status, className, testId }) {
  const s = STATUS_COLORS[status] || { c: "#D6AE57", bg: "rgba(214,174,87,0.12)" };
  return (
    <span
      data-testid={testId}
      className={cn("inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-wide", className)}
      style={{ color: s.c, background: s.bg, border: `1px solid ${s.c}33` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.c }} />
      {status}
    </span>
  );
}

export function Pill({ children, color = "#D6AE57", className }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold", className)}
      style={{ color, background: `${color}1a`, border: `1px solid ${color}33` }}>
      {children}
    </span>
  );
}

export function Metric({ label, value, sub, color, testId, mono = true }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wider text-[var(--text-muted)]">{label}</div>
      <div data-testid={testId} className={cn("mt-0.5 font-semibold text-[var(--text)]", mono && "tnum")} style={color ? { color } : {}}>
        {value}
      </div>
      {sub && <div className="text-[11px] text-[var(--text-sec)] mt-0.5">{sub}</div>}
    </div>
  );
}

export function DataStatusBadge({ status }) {
  const live = status === "LIVE";
  const color = live ? "#21C58E" : "#F5B942";
  const label = status === "DEMO" ? "DEMO / HISTORICAL" : status;
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide"
      style={{ color, background: `${color}1a`, border: `1px solid ${color}33` }} data-testid="data-status-badge">
      <span className="h-1.5 w-1.5 rounded-full animate-pulse" style={{ background: color }} />
      {label}
    </span>
  );
}
